import "./polyfill";
import $ from "jquery";

import { Alert } from "./nber/alerts/Alert";
// import { AnimatedHeader } from "./nber/animations/AnimatedHeader";
import { AccessibleLabels } from "./nber/forms/AccessibleLabels";
import { PasswordToggle } from "./nber/forms/PasswordToggle";
import { ClickableCard } from "./nber/helpers/ClickableCard";
import { SimpleAccordion } from "./nber/accordions/SimpleAccordion";
import PrimaryNav from "./nber/modules/PrimaryNav.js";
import { Hamburger } from "./nber/modules/Hamburger.js";
import { AffiliatesSlideshow } from "./nber/sliders/AffiliatesSlideshow.js";
import { listingInit } from "./nber/search/index.js";
// import { sitewideAlert } from "./nber/sitewide-alert/index.js";
import { PauseAllAnimations } from "./nber/animations/PauseAllAnimations";
import { BackToTop } from "./nber/animations/BackToTop";
import initSearchMenu from "./nber/modules/initSearchMenu";
import { loginInit } from "./nber/user/index.js";
import { agendaInit } from "./nber/conference-agenda/index.js";
import { ExpandableList } from "./nber/helpers/expandableList";
import { ResponsiveTables } from "./nber/modules/ResponsiveTables";
import { CopyLink } from "./nber/helpers/CopyLink";
import { copyBtnId, copyTextClass, initCopyTextField } from "./nber/forms/CopyTextField.js";
// import { initExpandableText } from "./nber/helpers/expandable-text/initExpandableText.js";

// import { FootnoteLinkFix } from "./nber/helpers/FootnoteLinkFix";

// Alerts
const $alert = $(".js-alert");
if ($alert.length) {
  const alerts = $.makeArray($alert).map( el => {
    return new Alert($(el));
  });
}

// AnimatedHeader
// Somewhat more simplified than other behaviors, as it's restricted to the home page.
// const $animatedheader = $(".js-animated-header");
// if ($animatedheader.length) {
//   AnimatedHeader();
// }

// PauseAllAnimations
const $pauseallanimations = $(".js-pause-animation");
if ($pauseallanimations.length) {
  const pauseallanimations = $.makeArray($pauseallanimations).map( el => {
    return new PauseAllAnimations($(el));
  });
}

// AccessibleLabels
const $accessiblelabel = $(".js-label");
if ($accessiblelabel.length) {
  const accessiblelabel = $.makeArray($accessiblelabel).map( el => {
    return new AccessibleLabels($(el));
  });
}

// PasswordToggle
const $passwordtoggle = $(".js-password");
if ($passwordtoggle.length) {
  const passwordtoggle = $.makeArray($passwordtoggle).map( el => {
    return new PasswordToggle($(el));
  });
}

// Clickable Cards
const $clickablecards = $(".js-clickable-card");
if ($clickablecards.length) {
  const clickablecards = $.makeArray($clickablecards).map( el => {
    return new ClickableCard($(el));
  });
}
// Expandable List
document.querySelectorAll(".js-expandable-list").forEach((el) => {
  return new ExpandableList(el);
});

// Simple accordions
const $simpleaccordions = $(".js-accordion");
if ($simpleaccordions.length) {
  const simpleaccordions = $.makeArray($simpleaccordions).map( el => {
    return new SimpleAccordion($(el), false);
  });
}

const $navaccordions = $(".js-nav-accordion");
if ($navaccordions.length) {
  const navaccordions = $.makeArray($navaccordions).map( el => {
    return new SimpleAccordion($(el), ["small"]);
  });
}

// Primary Nav
const $primaryNavItems = $('.js-primary-nav').find('.primary-nav__item');
if ($primaryNavItems.length > 0) {
  const $subNavItems = $('.js-primary-nav').find('.primary-nav__subitem, .primary-nav__dropdown-link, .primary-nav__sublist-heading.link--arrow');
  PrimaryNav($primaryNavItems, $subNavItems);
}

// Mobile nav
const $hamburgers = $(".js-hamburger");
if ($hamburgers.length) {
  const hamburgers = $.makeArray($hamburgers).map( el => {
    return new Hamburger($(el), true, true, ".header__user--mobile", ".header__utility--mobile");
  });
}

// Search Menu
const searchMenu = $(".js-search-menu");
if (searchMenu.length) {
  initSearchMenu(searchMenu[0]);
}

// Affiliates Slideshow
const $slideshowAffiliates = $(".js-slideshow-affiliates");
if ($slideshowAffiliates.length) {
  const slideshowAffiliates = $.makeArray($slideshowAffiliates).map( el => {
    return new AffiliatesSlideshow($(el));
  });
}

if ($(".js-search-mountnode").length) {
  // There can be more than one per page.
  $(".js-search-mountnode").each(function (i, el) {
    var container_id = $(this).data('id');
    listingInit(document.querySelector('div[data-id="' + container_id + '"]'), container_id);
  });
}

// Copy text field 
if ($(`.${copyTextClass}`).length && $(`#${copyBtnId}`).length) {
  initCopyTextField();
}

// Expandable text
// initExpandableText();

loginInit();
agendaInit();
// sitewideAlert();
